const Footer = () => {
    return (
        <div className="footer">
            Made with&nbsp;<strong>React</strong>&nbsp;at&nbsp;
            <strong>Le Reacteur</strong>&nbsp;by&nbsp;
            <a
                href="https://github.com/csengmany"
                target="_blank"
                rel="noopener noreferrer"
            >
                Cathy
            </a>
        </div>
    );
};

export default Footer;
